import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAbsoluteImageUrl } from '../utils/imageUtils';

/**
 * Componente para visualizar imagens diretamente
 * Este componente é usado para visualizar imagens sem redirecionar para o dashboard
 */
const ImageViewer: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState<string>('');
  const [error, setError] = useState<string>('');
  
  useEffect(() => {
    // Obter a URL da imagem a partir dos parâmetros da URL
    const params = new URLSearchParams(location.search);
    let imagePath = params.get('path');
    
    if (!imagePath) {
      setError('URL da imagem não fornecida');
      return;
    }
    
    // Decodificar a URL se estiver codificada
    try {
      // Decodificar duas vezes para lidar com dupla codificação
      if (imagePath.includes('%2F')) {
        imagePath = decodeURIComponent(imagePath);
      }
      if (imagePath.includes('%2F')) {
        imagePath = decodeURIComponent(imagePath);
      }
    } catch (e) {
      console.error('Erro ao decodificar URL:', e);
    }
    
    console.log('Caminho da imagem decodificado:', imagePath);
    
    // Garantir que o caminho comece com /uploads/
    if (!imagePath.startsWith('/uploads/')) {
      if (imagePath.includes('/uploads/')) {
        imagePath = '/uploads/' + imagePath.split('/uploads/')[1];
      } else {
        imagePath = '/uploads/photos/' + imagePath.split('/').pop();
      }
    }
    
    // Construir URL absoluta da imagem
    const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;
    const absoluteUrl = `${baseUrl}${imagePath}`;
    
    console.log('URL absoluta da imagem:', absoluteUrl);
    setImageUrl(absoluteUrl);
  }, [location]);
  
  // Voltar para a página anterior
  const handleBack = () => {
    navigate(-1);
  };
  
  // Abrir a imagem em uma nova aba
  const handleOpenInNewTab = () => {
    if (imageUrl) {
      window.open(imageUrl, '_blank');
    }
  };
  
  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h2>Erro ao carregar imagem</h2>
        <p>{error}</p>
        <button 
          onClick={handleBack}
          style={{
            padding: '10px 20px',
            background: '#2e7d32',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop: '20px'
          }}
        >
          Voltar
        </button>
      </div>
    );
  }
  
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      height: '100vh',
      padding: '20px',
      background: '#f5f5f5'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '800px',
        marginBottom: '20px'
      }}>
        <button 
          onClick={handleBack}
          style={{
            padding: '10px 20px',
            background: '#2e7d32',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Voltar
        </button>
        
        <button 
          onClick={handleOpenInNewTab}
          style={{
            padding: '10px 20px',
            background: '#f57c00',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Abrir em nova aba
        </button>
      </div>
      
      {imageUrl && (
        <div style={{
          maxWidth: '100%',
          maxHeight: 'calc(100vh - 100px)',
          overflow: 'auto',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          background: 'white',
          padding: '10px'
        }}>
          <img 
            src={imageUrl} 
            alt="Imagem" 
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain'
            }}
            onError={() => setError('Erro ao carregar imagem. A imagem pode não existir ou você não tem permissão para acessá-la.')}
          />
        </div>
      )}
    </div>
  );
};

export default ImageViewer;
